import { Tooltip, TooltipProps } from '@mui/material';
import React, { useState } from 'react';

export default function CustomTooltip(props: TooltipProps) {
  const [open, setOpen] = useState(false);

  return (
    <Tooltip
      {...props}
      placement="top"
      arrow
      componentsProps={{ tooltip: { sx: { px: 4, py: 2 } } }}
      onClose={() => setOpen(false)}
      open={open}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setOpen(true);
      }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(true)}
    ></Tooltip>
  );
}
